// Rep Agreement → Word.
//
// The agreement is built in the browser (see RepAgreementForm), so the document
// is posted up and comes back as a real .docx. It cannot go through `api` —
// that unwraps a JSON envelope this response does not have.

const FALLBACK_NAME = 'Representation Agreement.docx';

// The server names the file; this is the same name it puts in the header.
function fileNameFrom(response) {
    const header = response.headers.get('Content-Disposition') || '';
    const match = header.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
    return match ? decodeURIComponent(match[1]) : FALLBACK_NAME;
}

// The endpoint is a converter, not a record: it reads and writes nothing, and
// names the file from what it is given. Every browser-built document goes
// through it - the Representation Agreement, its addenda, and the PSA - so the
// generic name is the one new callers should use.
// fontSize, in points, sets the body text of the .docx where that should not be
// the converter's 10.5pt default. It does not affect the printed form.
export function downloadDocumentWord(html, filename, fontSize) {
    return downloadRepAgreementWord(html, filename, fontSize);
}

export function downloadRepAgreementWord(html, filename, fontSize) {
    const xsrf = document.cookie.match(/(^|; )XSRF-TOKEN=([^;]*)/);
    const headers = { 'Content-Type': 'application/json' };
    if (xsrf) headers['X-XSRF-TOKEN'] = decodeURIComponent(xsrf[2]);

    return fetch('/api/v1/documents/rep-agreement/word', {
        method: 'POST',
        headers,
        credentials: 'same-origin',
        body: JSON.stringify({ html, filename, fontSize }),
    }).then((response) => {
        // A refusal answers with the JSON envelope rather than a file.
        if (!response.ok) {
            return response.json()
                .catch(() => ({}))
                .then((payload) => { throw new Error(payload.message || 'Could not build the Word document'); });
        }
        return response.blob().then((blob) => ({ blob, name: fileNameFrom(response) }));
    }).then(({ blob, name }) => {
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = name;
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
    });
}
